<h1 mat-dialog-title class="text-center">{{ headlineKey | translate : headlineDefault : headlineData }}</h1>
<mat-dialog-content>
    <div>
        <p class="text-center">{{questionKey | translate : questionDefault : questionData}}</p>
        <mat-form-field appearance="outline">
            <textarea matInput placeholder="{{'Turbo.core.PromptDialog.txtResponse' | translate : 'Enter response here...'}}" [(ngModel)]="response" matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="5"></textarea>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button type="button" mat-raised-button color="primary" [mat-dialog-close]="response" [disabled]="!(response && response.trim().length)">{{ 'turbo.core.PromptDialog.cmdConfirm' | translate : 'OK' }}</button>
  <button mat-button type="button" mat-raised-button color="accent" [mat-dialog-close]="false">{{ 'turbo.core.PromptDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
